import baseTheme from "@insite/mobius/globals/baseTheme";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            titleButton: css`
                ${baseTheme.modal.defaultProps?.cssOverrides?.titleButton}

                &:active {
                    border-color: transparent;
                    background: transparent;
                }
            `,
        },
    },
};
